import { AppKitNetwork, mainnet, sepolia } from '@reown/appkit/networks'
import { createAppKit } from '@reown/appkit/react'
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'
import * as Sentry from '@sentry/react'
import { type ReactNode } from 'react'
import { type Config, cookieStorage, createStorage, WagmiProvider } from 'wagmi'
import { SearchProvider } from '@/context/search-context'

export const projectId = process.env.WAGMI_PROJECT_ID || import.meta.env.VITE_WAGMI_PROJECT_ID

if (!projectId) {
	throw new Error('Project ID is not defined')
}

export const networks: [AppKitNetwork, ...AppKitNetwork[]] = [mainnet, sepolia]

export const wagmiAdapter = new WagmiAdapter({
	projectId,
	networks,
	storage: createStorage({
		storage: cookieStorage,
	}),
})

let url
if (import.meta.env.DEV) {
	url = process.env.BASE_URL || import.meta.env.VITE_BASE_URL || 'http://localhost:3000'
} else {
	url = process.env.BASE_URL || import.meta.env.VITE_BASE_URL || 'https://certichain.io'
}

// Set up metadata
const metadata = {
	name: 'GaiaDEX',
	description: 'GaiaDEX',
	url: url, // origin must match your domain & subdomain
	icons: ['https://assets.reown.com/reown-profile-pic.png'],
}
createAppKit({
	adapters: [wagmiAdapter],
	networks: networks,
	projectId,
	metadata,
	defaultNetwork: sepolia,
	features: {
		analytics: false, // Optional - defaults to your Cloud configuration
		socials: ['google'],
		email: true,
		swaps: true,
		send: true,
		emailShowWallets: false,
	},
	defaultAccountTypes: {
		eip155: 'eoa',
	},
	themeMode: 'light',
	themeVariables: {
		'--w3m-color-mix': '#ffffff',
		'--w3m-accent': '#1b1718',
		'--w3m-color-mix-strength': 50,
		'--w3m-font-family': 'ui-sans-serif, system-ui',
		'--w3m-font-size-master': '9px',
		'--w3m-border-radius-master': '0.5px',
	},
})

Sentry.init({
	dsn: import.meta.env.VITE_SENTRY_DSN,
	environment: 'production',
	enabled: import.meta.env.PROD,
	sendDefaultPii: true,
	integrations: [],
	tracesSampleRate: 0,
})

function ContextList({ children }: { children: ReactNode }) {
	return (
		<WagmiProvider config={wagmiAdapter.wagmiConfig as Config}>
			<SearchProvider>{children}</SearchProvider>
		</WagmiProvider>
	)
}

export default ContextList
